import { render, staticRenderFns } from "./OrderModifyDeposit.vue?vue&type=template&id=83cdd32e&scoped=true"
import script from "./OrderModifyDeposit.vue?vue&type=script&lang=js"
export * from "./OrderModifyDeposit.vue?vue&type=script&lang=js"
import style0 from "./OrderModifyDeposit.vue?vue&type=style&index=0&id=83cdd32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cdd32e",
  null
  
)

export default component.exports